/* Oureja storefront behaviour — scroll reveal, sticky CTA, product gallery.
   Vanilla, no dependencies, and every effect is optional. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal -------------------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('.oh-reveal:not(.is-in)');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---- sticky mobile CTA ---------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-oh-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-oh-sticky-after]') || document.querySelector('.oh-hero');
    if (!anchor) return;
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---- product: variant picker + gallery ------------------------------ */
  function initProduct(root) {
    var data = root.querySelector('[data-oh-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var idInput = root.querySelector('[data-oh-variant-id]');
    var priceEl = root.querySelector('[data-oh-price]');
    var compareEl = root.querySelector('[data-oh-compare]');
    var addBtn = root.querySelector('[data-oh-add]');
    var stickyPrice = document.querySelector('[data-oh-sticky-price]');
    var mainImg = root.querySelector('[data-oh-main-image]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
    }

    function select(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        var label = addBtn.querySelector('[data-oh-add-label]');
        if (label) label.textContent = v.available ? addBtn.dataset.labelAvailable : 'Sold out';
      }
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.src = v.featured_image.src;
        if (v.featured_image.alt) mainImg.alt = v.featured_image.alt;
      }
    }

    root.querySelectorAll('[data-oh-variant-option]').forEach(function (input) {
      input.addEventListener('change', function () { select(this.value); });
      if (input.checked) select(input.value);
    });

    /* gallery thumbnails */
    root.querySelectorAll('[data-oh-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = this.dataset.ohThumb;
        mainImg.alt = this.dataset.ohThumbAlt || mainImg.alt;
        root.querySelectorAll('[data-oh-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  function boot() {
    initReveal();
    initSticky();
    document.querySelectorAll('[data-oh-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Theme editor re-renders sections without a full reload */
  document.addEventListener('shopify:section:load', boot);
})();
